module.exports = __webpack_public_path__ + "static/media/Group 27.be1d173b.svg";